import FinanceAnalysis from 'components/organisms/finance-analysis/FinanceAnalysis'
import React from 'react'

const AnalysisCost = () => {
  return (
    <FinanceAnalysis />
  )
}

export default AnalysisCost